import { Link } from "react-router-dom";
import type { WorkItem } from "@/mocks/works";

interface WorkCardProps {
  work: WorkItem;
}

export default function WorkCard({ work }: WorkCardProps) {
  return (
    <Link
      to={`/works/detail/${work.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-52 w-full overflow-hidden">
        <img
          src={work.cover}
          alt={`${work.title} - 张津瑜作品封面`}
          title={`${work.title} + 张津瑜作品`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute right-3 top-3 rounded-md bg-primary-900/80 px-2.5 py-1 font-label text-xs font-medium text-background-50 backdrop-blur">
          {work.year}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <span className="font-label text-xs font-semibold uppercase tracking-wider text-accent-600">
          {work.type}
        </span>
        <h3 className="mt-2 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
          {work.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {work.summary}
        </p>
        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4">
          <span className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-eye-line" />
            {work.views.toLocaleString()}
          </span>
          <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600">
            查看详情
            <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1" />
          </span>
        </div>
      </div>
    </Link>
  );
}